import { useFetch } from 'utils/fetch'

export function useVoices() {
  return useFetch('/v1/voices', { queryKey: ['voices'], dataKey: ['voices'], staleTime: Infinity })
}
